<template>
  <form
    class="form"
    method="POST"
    action="javascript:;"
    @submit.prevent="submit"
  >
    <FormError v-if="formError.length > 0" :errorMessages="formError" />

    <FormLoading v-if="!formReady" />

    <CardBase v-else>
      <template #header>{{ $route.meta.title }}</template>
      <template #content>
        <FormRow class="mb-4" :required="true">
          <template #label>Bank Group</template>
          <template #field>
            <input
              class="form__input bg-gray-400 bg-opacity-25"
              :value="formData.bank_group.name"
              readonly
              disabled
            />
          </template>
        </FormRow>

        <FormRow class="mb-4" :required="true">
          <template #label>Bank</template>
          <template #field>
            <input
              class="form__input bg-gray-400 bg-opacity-25"
              :value="formData.bank.name"
              readonly
              disabled
            />
          </template>
        </FormRow>

        <FormRow class="mb-4" :required="true">
          <template #label>Account holder</template>
          <template #field>
            <input
              class="form__input bg-gray-400 bg-opacity-25"
              :value="formData.holder"
              readonly
              disabled
            />
          </template>
        </FormRow>

        <FormRow class="mb-4" :required="true">
          <template #label>Account number</template>
          <template #field>
            <input
              class="form__input bg-gray-400 bg-opacity-25"
              :value="formData.number"
              readonly
              disabled
            />
          </template>
        </FormRow>

        <FormRow class="mb-4" :required="true">
          <template #label>Reason for Deletion</template>
          <template #field>
            <textarea
              class="form__input"
              placeholder="Reason for Deletion"
              rows="5"
              v-model="reason"
            ></textarea>
            <div class="form-error" v-if="$v.reason.$error && formSubmitted">
              <span class="form-error__text" v-if="!$v.reason.required"
                >This field is required.</span
              >
            </div>
          </template>
        </FormRow>

        <FormDataLog :data="formData" v-if="!formCreate" />
      </template>

      <template #footer>
        <div
          class="bg-red-600 text-white p-6 mb-4 text-sm font-medium"
          v-if="deleteMsg"
        >
          Note: {{ deleteMsg }}
        </div>
        <FormRow class="mb-0">
          <template #field>
            <BaseButton type="submit" buttonClass="danger"
              >Delete Bank Account</BaseButton
            >
          </template>
          <template #link>
            <div class="ml-4">
              or
              <router-link :to="{ name: 'MemberList' }" class="link ml-2"
                >Back to List Members</router-link
              >
            </div>
          </template>
        </FormRow>
      </template>
    </CardBase>
  </form>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { submitFormMixin } from "@/mixins/submitFormMixin";

export default {
  mixins: [submitFormMixin],
  validations: {
    reason: {
      required,
    },
  },
  data: () => {
    return {
      listMemberBank: [],
      listMemberBankLoading: false,
      replacementRequired: false,
      reason: "",
      force_delete: 0,
      formData: {},
      deleteMsg: "",
    };
  },
  watch: {
    "$route.params.id": function (id) {
      if (id) {
        this.fetchData(id);
        this.formCreate = false;
      } else {
        this.formCreate = true;
      }
    },
  },
  computed: {
    submitUrl() {
      return this.formCreate
        ? "/" + this.$route.meta.endpoint(this.$route)
        : "/" +
            this.$route.meta.endpoint(this.$route) +
            "/" +
            this.formData.uuid;
    },
    fetchEndPoint() {
      return this.$route.meta.endpoint(this.$route);
    },
  },
  methods: {
    fetchData(id) {
      this.formReady = false;

      const itemId = id ? id : this.formData.id;

      this.$http
        .get(
          process.env.VUE_APP_API_URL + "/" + this.fetchEndPoint + "/" + itemId
        )
        .then((res) => {
          if (res.status == 200) {
            const { data } = res.data;
            this.formData = { ...this.formData, ...data };
            this.formReady = true;
          }
        })
        .catch((err) => {
          if (err.response.status == 404) {
            this.$router.push({ name: this.$route.meta.baseRoute });
          } else if (err.response.status == 500) {
            this.formError = [];
            this.formError[0] = err.response.data.message;
          }
        })
        .finally(() => {});
    },
    getListMemberBank() {
      this.listMemberBank = [];
      this.listMemberBankLoading = true;
      this.replacementRequired = true;
      this.$http
        .get(
          process.env.VUE_APP_API_URL +
            "/member/" +
            this.$route.params.memberId +
            "/bank-account/?exclude_uuid=" +
            this.$route.params.id
        )
        .then((res) => {
          if (res.status == 200) {
            const response = res.data;

            if (response) {
              this.listMemberBank = response.data;
            }
          }
        })
        .finally(() => {
          this.listMemberBankLoading = false;
        });
    },
    submit() {
      if (!this.formLoading) {
        this.formSubmitted = true;
        this.$v.$touch();

        if (this.$v.$invalid) {
          return;
        }

        this.formLoading = true;
        this.$store.commit("toggleLoading");

        let formData = {
          reason: this.reason,
          force_delete: this.force_delete,
        };

        this.$http({
          method: "delete",
          url:
            process.env.VUE_APP_API_URL +
            "/member/" +
            this.$route.params.memberId +
            "/bank-account/" +
            this.$route.params.id,
          data: formData,
        })
          .then((res) => {
            if (res.status == 200) {
              this.$swal({
                title: "All done!",
                text: res.data.message,
                icon: "success",
              }).then(() => {
                this.$store.commit("toggleLoading");
                this.$router.push({
                  name: "MemberProfile",
                  params: { memberId: this.$route.params.memberId },
                });
              });
            }
          })
          .catch((err) => {
            if (err.response.status == 409) {
              this.$store.commit("toggleLoading");
              this.deleteMsg = err.response.data.data.member_bank_account;
              this.force_delete = 1;
            }
          })
          .finally(() => {
            this.formSubmitted = false;
            this.formLoading = false;
          });
      }
    },
  },
};
</script>
